import { useMutation } from '@tanstack/react-query'
import { loginFetch } from 'store/middlewares/auth.crud'
import { secretStorage } from 'config'
import { application } from 'store/hooks'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'

const LoginCrud = () => {
    const setAppData = application.useInitAppData()

    const { mutateAsync: loginUser, isPending: loginLoading, error } = useMutation({
        mutationFn: loginFetch,
        onSuccess: (res) => {
            if (res.data) {
                const user = res.data
                secretStorage.setItem("user", user)
                setAppData(user)
            }
        },
        onError: (error) => {
            const { response } = error
            if (response.status === 401) {
                toast.error("שם משתמש או סיסמה שגוי", toastConfig);
            }
            else if (response.status === 400) {
               
            }
            else toast.error("שגיאה, נסה שוב מאוחר יותר", toastConfig);

            return error
        }
    })

    const login = async (values) => {
        await loginUser(values)
    }

    return {
        login,
        loginLoading
    }
}

export default LoginCrud